var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download-store-img"},[_c('img',{staticClass:"xl:w-auto lg:w-auto md:w-full",attrs:{"src":_vm.img,"alt":"Download Store Phone"}})])}
var staticRenderFns = []

export { render, staticRenderFns }